import fetch from './fetch'

class PartnerApi {
	public setAuditRule(form: object) {
		return fetch({
			url: 'injury/resource/partnersetting/save',
			method: 'post',
			data: form,
		})
	}

	public getAccountsByCompanyId(form: any) {
		return fetch({
			url: 'injury/check/setting/accountsByCompanyId',
			params: form,
		})
	}

	public getVisitorByArea(form: any) {
		return fetch({
			url: 'injury/check/setting/getVisitorByArea',
			method: 'post',
			data: form,
		})
	}

	public saveCheckRule(form: any) {
		return fetch({
			url: 'injury/check/setting/save',
			method: 'post',
			data: form,
		})
	}

	public getCheckList(form: any) {
		return fetch({
			url: 'injury/check/setting/list',
			method: 'post',
			data: form,
		})
	}

	public getCheckDetail(id: string) {
		return fetch({
			url: 'injury/check/setting/detail',
			params: {
				id,
			},
		})
	}

	public beginCheck(id: string) {
		return fetch({
			url: 'injury/check/setting/begin',
			params: {
				id,
			},
		})
	}

	public cancelCheck(id: string) {
		return fetch({
			url: 'injury/check/setting/cancel',
			params: {
				id,
			},
		})
	}

	public getOrderList(form: any) {
		return fetch({
			url: 'injury/order/partner/orderlist',
			method: 'post',
			data: form,
		})
	}

	public getDispatchList(orderId: any) {
		return fetch({
			url: 'injury/order/partner/dispartchlist',
			params: {
				orderId,
			},
		})
	}

	public getOrder(form: any) {
		return fetch({
			url: 'injury/order/partner/orderdetail',
			params: form,
		})
	}

	public getFullOrder(orderId: any) {
		return fetch({
			url: 'injury/order/partner/checkorderdetail',
			params: {
				orderId,
			},
		})
	}

	public getPartnerList(form: any) {
		return fetch({
			url: 'injury/partner/list',
			method: 'post',
			data: form,
		})
	}

	public getPartnerDetail(partnerId: any) {
		return fetch({
			url: 'injury/partner/detail',
			method: 'post',
			params: {
				partnerId,
			},
		})
	}

	public exportOrderTreadList(form: any) {
		return fetch({
			url: 'injury/partner/exportOrderTreadList',
			method: 'post',
			data: form,
			timeout: 0,
			responseType: 'blob',
		})
	}

	public exportVisitor(form: any) {
		return fetch({
			url: 'injury/visitor/export',
			method: 'post',
			data: form,
			timeout: 0,
			responseType: 'blob',
		})
	}

	public getDailyList(form: any) {
		return fetch({
			url: 'injury/partner/dailyList',
			method: 'post',
			data: form,
		})
	}

	public getTrendOrderList(form: any) {
		return fetch({
			url: 'injury/partner/trendOrderList',
			method: 'post',
			data: form,
		})
	}

	public exportOrderList(form: any) {
		return fetch({
			url: 'injury/order/partner/exportorderlist',
			method: 'post',
			data: form,
			timeout: 0,
			responseType: 'blob',
		})
	}

	public getTaskLog(form: any) {
		return fetch({
			url: 'injury/tasklog/getTaskLog',
			method: 'get',
			params: form,
		})
	}
}
export default new PartnerApi()
